"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RoleFormScreen = RoleFormScreen;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("@heroui/react");
var react_2 = require("react");
var react_router_dom_1 = require("react-router-dom");
var page_header_1 = require("../../components/common/page-header");
var roles_1 = require("../../features/apis/roles");
var use_error_handler_1 = require("../../hooks/use-error-handler");
var permissions_1 = require("../../interfaces/permissions");
var moduleLabels = {
    users: "Users",
    roles: "Roles",
    organizations: "Organizations",
    customers: "Customers",
    products: "Products",
    stock: "Stock",
    orders: "Orders",
    disbursements: "Disbursements",
    ussd: "USSD",
    reports: "Reports",
    audit: "Audit",
    system: "System",
};
var actionLabels = {
    view: "View",
    create: "Create",
    update: "Update",
    delete: "Delete",
    upload: "Upload",
    authorize: "Authorize",
    export: "Export",
};
function RoleFormScreen() {
    var _this = this;
    var navigate = (0, react_router_dom_1.useNavigate)();
    var id = (0, react_router_dom_1.useParams)().id;
    var isEditing = !!id;
    var _a = (0, use_error_handler_1.useErrorHandler)(), handleError = _a.handleError, handleSuccess = _a.handleSuccess;
    var _b = (0, react_2.useState)(""), name = _b[0], setName = _b[1];
    var _c = (0, react_2.useState)(""), code = _c[0], setCode = _c[1];
    var _d = (0, react_2.useState)(""), description = _d[0], setDescription = _d[1];
    var _e = (0, react_2.useState)([]), permissions = _e[0], setPermissions = _e[1];
    var _f = (0, roles_1.useGetRoleQuery)(id, {
        skip: !id,
    }), roleData = _f.data, isLoadingRole = _f.isLoading, roleError = _f.error;
    var _g = (0, roles_1.useCreateRoleMutation)(), createRole = _g[0], isCreating = _g[1].isLoading;
    var _h = (0, roles_1.useUpdateRoleMutation)(), updateRole = _h[0], isUpdating = _h[1].isLoading;
    // Initialize permissions with all modules (only when creating new role)
    (0, react_2.useEffect)(function () {
        if (!isEditing) {
            var modules = Object.values(permissions_1.MODULES);
            var initialPermissions = modules.map(function (module) { return ({
                module: module,
                actions: {
                    view: false,
                    create: false,
                    update: false,
                    delete: false,
                    upload: false,
                    authorize: false,
                    export: false,
                },
            }); });
            setPermissions(initialPermissions);
        }
    }, [isEditing]);
    // Load role data when editing
    (0, react_2.useEffect)(function () {
        if (roleData === null || roleData === void 0 ? void 0 : roleData.content) {
            // The API returns {role: {...}} structure, but TypeScript types it as IRole
            // Handle both cases: nested {role: IRole} or direct IRole
            var content = roleData.content;
            var role_1 = "role" in content ? content.role : content;
            setName(role_1.name || "");
            setCode(role_1.code || "");
            setDescription(role_1.description || "");
            // Merge existing permissions with all modules
            var modules = Object.values(permissions_1.MODULES);
            var updatedPermissions = modules.map(function (module) {
                var _a;
                var existingPerm = (_a = role_1.permissions) === null || _a === void 0 ? void 0 : _a.find(function (p) { return p.module === module; });
                return {
                    module: module,
                    actions: (existingPerm === null || existingPerm === void 0 ? void 0 : existingPerm.actions) || {
                        view: false,
                        create: false,
                        update: false,
                        delete: false,
                        upload: false,
                        authorize: false,
                        export: false,
                    },
                };
            });
            setPermissions(updatedPermissions);
        }
    }, [roleData]);
    var handlePermissionChange = function (moduleIndex, action, checked) {
        setPermissions(function (prev) {
            var _a;
            var updated = __spreadArray([], prev, true);
            updated[moduleIndex] = __assign(__assign({}, updated[moduleIndex]), { actions: __assign(__assign({}, updated[moduleIndex].actions), (_a = {}, _a[action] = checked, _a)) });
            return updated;
        });
    };
    var handleSelectAllForModule = function (moduleIndex, checked) {
        setPermissions(function (prev) {
            var updated = __spreadArray([], prev, true);
            var actions = Object.values(permissions_1.ACTIONS);
            var newActions = {};
            actions.forEach(function (action) {
                newActions[action] = checked;
            });
            updated[moduleIndex] = __assign(__assign({}, updated[moduleIndex]), { actions: newActions });
            return updated;
        });
    };
    var handleSubmit = function () { return __awaiter(_this, void 0, void 0, function () {
        var activePermissions, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    activePermissions = permissions.filter(function (p) { return Object.values(p.actions).some(function (v) { return v; }); });
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 6, , 7]);
                    if (!isEditing) return [3 /*break*/, 3];
                    return [4 /*yield*/, updateRole({
                            id: id,
                            data: {
                                name: name,
                                description: description,
                                permissions: activePermissions,
                            },
                        }).unwrap()];
                case 2:
                    _a.sent();
                    handleSuccess("Role updated successfully");
                    return [3 /*break*/, 5];
                case 3: return [4 /*yield*/, createRole({
                        name: name,
                        code: code,
                        description: description,
                        permissions: activePermissions,
                    }).unwrap()];
                case 4:
                    _a.sent();
                    handleSuccess("Role created successfully");
                    _a.label = 5;
                case 5:
                    navigate("/roles");
                    return [3 /*break*/, 7];
                case 6:
                    error_1 = _a.sent();
                    handleError(error_1, {
                        defaultMessage: isEditing ? "Failed to update role" : "Failed to create role",
                    });
                    return [3 /*break*/, 7];
                case 7: return [2 /*return*/];
            }
        });
    }); };
    if (isEditing && isLoadingRole) {
        return ((0, jsx_runtime_1.jsx)("div", { className: "flex h-96 items-center justify-center", children: (0, jsx_runtime_1.jsx)(react_1.Spinner, { size: "lg", label: "Loading role..." }) }));
    }
    if (isEditing && roleError) {
        return ((0, jsx_runtime_1.jsxs)("div", { className: "flex h-96 flex-col items-center justify-center gap-4", children: [(0, jsx_runtime_1.jsx)("p", { className: "text-lg text-default-500", children: "Failed to load role" }), (0, jsx_runtime_1.jsx)(react_1.Button, { onPress: function () { return navigate("/roles"); }, children: "Back to Roles" })] }));
    }
    return ((0, jsx_runtime_1.jsxs)("div", { className: "space-y-6", children: [(0, jsx_runtime_1.jsx)(page_header_1.PageHeader, { title: isEditing ? "Edit Role" : "Create Role", description: isEditing ? "Update role details and permissions" : "Create a new role with permissions" }), (0, jsx_runtime_1.jsxs)("div", { className: "grid gap-6", children: [(0, jsx_runtime_1.jsxs)(react_1.Card, { className: "border border-divider", children: [(0, jsx_runtime_1.jsx)(react_1.CardHeader, { className: "border-b border-divider px-6 py-4", children: (0, jsx_runtime_1.jsx)("h2", { className: "text-lg font-semibold", children: "Basic Information" }) }), (0, jsx_runtime_1.jsx)(react_1.CardBody, { className: "p-6", children: (0, jsx_runtime_1.jsxs)("div", { className: "grid gap-4 md:grid-cols-2", children: [(0, jsx_runtime_1.jsx)(react_1.Input, { label: "Name", placeholder: "Enter role name", value: name, onValueChange: setName, isRequired: true }), (0, jsx_runtime_1.jsx)(react_1.Input, { label: "Code", placeholder: "Enter role code", value: code, onValueChange: function (value) { return setCode(value.toLowerCase()); }, isRequired: true, isDisabled: isEditing, description: "Unique identifier for the role" }), (0, jsx_runtime_1.jsx)(react_1.Input, { label: "Description", placeholder: "Enter role description", value: description, onValueChange: setDescription, className: "md:col-span-2" })] }) })] }), (0, jsx_runtime_1.jsxs)(react_1.Card, { className: "border border-divider", children: [(0, jsx_runtime_1.jsx)(react_1.CardHeader, { className: "border-b border-divider px-6 py-4", children: (0, jsx_runtime_1.jsx)("h2", { className: "text-lg font-semibold", children: "Permissions" }) }), (0, jsx_runtime_1.jsx)(react_1.CardBody, { className: "p-0", children: (0, jsx_runtime_1.jsx)("div", { className: "overflow-x-auto", children: (0, jsx_runtime_1.jsxs)("table", { className: "w-full", children: [(0, jsx_runtime_1.jsx)("thead", { className: "bg-default-50", children: (0, jsx_runtime_1.jsxs)("tr", { children: [(0, jsx_runtime_1.jsx)("th", { className: "sticky left-0 bg-default-50 px-6 py-3 text-left text-xs font-medium uppercase text-default-500", children: "Module" }), Object.entries(actionLabels).map(function (_a) {
                                                            var key = _a[0], label = _a[1];
                                                            return ((0, jsx_runtime_1.jsx)("th", { className: "px-4 py-3 text-center text-xs font-medium uppercase text-default-500", children: label }, key));
                                                        }), (0, jsx_runtime_1.jsx)("th", { className: "px-4 py-3 text-center text-xs font-medium uppercase text-default-500", children: "All" })] }) }), (0, jsx_runtime_1.jsx)("tbody", { className: "divide-y divide-divider", children: permissions.map(function (perm, moduleIndex) {
                                                    var allChecked = Object.values(perm.actions).every(function (v) { return v; });
                                                    var someChecked = Object.values(perm.actions).some(function (v) { return v; });
                                                    return ((0, jsx_runtime_1.jsxs)("tr", { className: "hover:bg-default-50", children: [(0, jsx_runtime_1.jsx)("td", { className: "sticky left-0 bg-content1 px-6 py-4 text-sm font-medium text-foreground", children: moduleLabels[perm.module] }), Object.values(permissions_1.ACTIONS).map(function (action) { return ((0, jsx_runtime_1.jsx)("td", { className: "px-4 py-4 text-center", children: (0, jsx_runtime_1.jsx)(react_1.Checkbox, { isSelected: perm.actions[action], onValueChange: function (checked) { return handlePermissionChange(moduleIndex, action, checked); }, size: "sm" }) }, action)); }), (0, jsx_runtime_1.jsx)("td", { className: "px-4 py-4 text-center", children: (0, jsx_runtime_1.jsx)(react_1.Checkbox, { isSelected: allChecked, isIndeterminate: someChecked && !allChecked, onValueChange: function (checked) { return handleSelectAllForModule(moduleIndex, checked); }, size: "sm" }) })] }, perm.module));
                                                }) })] }) }) })] }), (0, jsx_runtime_1.jsxs)("div", { className: "flex justify-end gap-3", children: [(0, jsx_runtime_1.jsx)(react_1.Button, { variant: "bordered", onPress: function () { return navigate("/roles"); }, children: "Cancel" }), (0, jsx_runtime_1.jsx)(react_1.Button, { color: "primary", onPress: handleSubmit, isLoading: isCreating || isUpdating, isDisabled: !name || !code, children: isEditing ? "Update Role" : "Create Role" })] })] })] }));
}
